import Banner from './components/Banner';

export default Banner;



// WEBPACK FOOTER //
// ./src/components/alerts/index.jsx